import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hymotsESocketHelper } from 'src/app/helpers';
import { socketActions } from 'src/app/redux/actions';
import { urlsConfig } from 'src/configs';
import { reduxRootTypes } from 'src/types';

const HymotseConnectionHandler = () => {
  const dispatch = useDispatch();
  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { hymotsDB, eventId } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { hymotseConnected } = useSelector((state: reduxRootTypes.RootStateType) => state.socketState);

  useEffect(() => {
    if (hymotseConnected) {
      hymotsESocketHelper.sendMessage({
        mesajTipi: 13, // DENEY
        mesajAltTipi: 64, // HYMOTS_E_UYGUNLUK_GUNCELLEMESI
        icerik: {},
        oyunId: hymotsDB || 0,
      });
    }
  }, [hymotseConnected]);

  useEffect(() => {
    if (userState.token && userState.authenticated && hymotsDB && eventId) {
      const gameId = Number(hymotsDB.toString());

      hymotsESocketHelper.createConnection((socketStatus: boolean) => {
        dispatch(socketActions.hymotseConnected(socketStatus));

        socketStatus && hymotsESocketHelper.connectionRequest(gameId, eventId);
      });
    }
  }, [userState.token, userState.authenticated, hymotsDB, eventId]);

  return null;
};

export default HymotseConnectionHandler;
